import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "../lib/api";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-[#0E0E0E] border border-white/10 p-8 space-y-5"
        data-testid="admin-login-form"
      >
        <div>
          <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-[#FF2800]">
            // Race Control
          </p>
          <h1 className="af-display text-3xl font-black uppercase tracking-tight mt-1 flex items-center gap-2">
            <Lock size={20} /> Admin
          </h1>
        </div>
        <label className="block">
          <span className="af-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 block mb-1.5">
            Email
          </span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full bg-black border border-white/15 px-3 py-2.5 text-sm focus:outline-none focus:border-[#FF2800] transition-colors"
            data-testid="admin-email-input"
          />
        </label>
        <label className="block">
          <span className="af-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 block mb-1.5">
            Password
          </span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full bg-black border border-white/15 px-3 py-2.5 text-sm focus:outline-none focus:border-[#FF2800] transition-colors"
            data-testid="admin-password-input"
          />
        </label>
        {error && (
          <p className="text-[#FF2800] text-sm" data-testid="admin-login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#FF2800] text-white font-semibold uppercase tracking-wider py-3.5 hover:bg-[#CC2000] disabled:opacity-50 transition-colors text-sm"
          data-testid="admin-login-submit"
        >
          {loading ? "Checking…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
